import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import Loading from "react-simple-loading";
import logo from "../assets/images/logo.png";
import "react-datepicker/dist/react-datepicker.css";

const DownloadRecord = () => {
  const [isBtn, setIsBtn] = useState(false);
  const [inputError, setInputError] = useState(false);

  const [downloadData, setDownloadData] = useState({
    work_order_no: "",
    patient_dob: "",
    otp: ""
  });

  const downloadMedicalRecord = async () => {
    setInputError(false);

    if (
      !downloadData.work_order_no ||
      !downloadData.patient_dob ||
      !downloadData.otp ||
      !/^\d{2}\/\d{2}\/\d{4}$/.test(downloadData.patient_dob)
    ) {
      setInputError(true);
      return;
    }

    setIsBtn(true);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/download-medical-record`,
        {
          params: downloadData,
          responseType: "blob",
          withCredentials: true
        }
      );

      const contentType = response.headers["content-type"];

      /* ---------- JSON ERROR ---------- */
      if (contentType?.includes("application/json")) {
        const text = await response.data.text();
        const json = JSON.parse(text);
        Swal.fire({
          icon: "error",
          title: "Medical Record",
          text: json.message || "Download failed"
        });
        return;
      }

      /* ---------- FILE DOWNLOAD ---------- */
      const blob = response.data;

      let filename = "medical-record";

      // Prefer server filename
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match?.[1]) filename = match[1];
      } 
      // Fallback by MIME type (SAFE)
      else {
        if (contentType.includes("pdf")) filename += ".pdf";
        else if (contentType.includes("zip")) filename += ".zip";
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        icon: "success",
        title: "Medical Record",
        text: "Medical record downloaded successfully"
      });

    } catch (error) {
      Swal.fire({
        icon: "error", title: "Medical Record",  text: error.message || "Download error"
      });
      console.error("Download error:", error);
    } finally {
      setIsBtn(false);
    }
  };

  return (
    <div className="card card-medium">
      <div className="card-header text-center">
        <img src={logo} alt="MedRecAps" />
      </div>

      <div className="card-body">
        <h4 className="text-center my-4 text-primary">DOWNLOAD MEDICAL RECORD</h4>

        <div className="container">
          <div className="row py-2 gx-3">

            <div className="col-xl-12 mb-4">
              <label>CASE #*</label>
              <input
                className="form-control"
                value={downloadData.work_order_no}
                onChange={e =>
                  setDownloadData({ ...downloadData, work_order_no: e.target.value })
                }
              />
            </div>

            <div className="col-xl-12 mb-4">
              <label>DOB*</label>
              <DatePicker
                className="form-control"
                selected={downloadData.patient_dob ? new Date(downloadData.patient_dob) : null}
                onChange={date => {
                  const d = new Date(date);
                  setDownloadData({
                    ...downloadData,
                    patient_dob: `${String(d.getMonth()+1).padStart(2,"0")}/${String(d.getDate()).padStart(2,"0")}/${d.getFullYear()}`
                  });
                }}
              />
            </div>

            <div className="col-xl-12 mb-4">
              <label>OTP*</label>
              <input
                type="password"
                className="form-control"
                value={downloadData.otp}
                onChange={e =>
                  setDownloadData({ ...downloadData, otp: e.target.value })
                }
              />
            </div>

            <div className="col-xl-12 text-center">
              <button
                className="btn btn-primary btn-lg"
                disabled={isBtn}
                onClick={downloadMedicalRecord}
              >
                {isBtn ? <Loading /> : "Download Medical Record"}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadRecord;
